import { render } from "./Lesson.vue?vue&type=template&id=2475f702&scoped=true"
import script from "./Lesson.vue?vue&type=script&lang=js"
export * from "./Lesson.vue?vue&type=script&lang=js"

import "./Lesson.vue?vue&type=style&index=0&id=2475f702&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src4026252432/src/luca_web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2475f702"]])

export default __exports__